export default __webpack_public_path__ + "static/media/BB_18.f957213e.png";